module.exports = __webpack_public_path__ + "static/media/history-white.64f17db7.svg";